import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class MFCreateMandateUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.createBankMandate(req);
    }
}
export default MFCreateMandateUseCase;
